<div class="container-fluid">
  <div class="card-panel mt-5 mb-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-5">
          <lib-page-header page-title="ORDEM DE FORNECIMENTO" image-title="assets/img/commerce-and-shopping.png"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            page-change="{{pagTitulo}}" show-change="true">
          </lib-page-header>
        </div>
        <div class="col-md-7">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/compras']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button *ngIf="entidade.id " data-toggle="modal" (click)="visualizarExclusao=true"
            class="btn btn-sm btn-outline-danger float-right mr-2">
            <img src="assets/img/global/bin_closed.png" alt="Exclusão" title="Excluir Ordem de Fornecimento" height="22"
              width="22">
          </button>
          <button (click)="submitForm()" type="submit" class="btn btn-outline-info float-right mr-4"
            style="font-size: 13px">Salvar O.F</button>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <div class="row">
        <div class="col-12">

          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home"
                aria-selected="true" (click)="selecionarTab(1)">Dados OF.</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile"
                aria-selected="false" (click)="selecionarTab(2)">Itens da OF.</a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
              <br />
              <div class="row">
                <div class="col-md-8">
                  <div class="form-row">
                    <div class="col-md-4 d-flex flex-column mt-1 form-group">
                      <strong style="font-size: 22px;  color: #426ea8">OF Nº:
                        {{("00000"+entidadeForm.get('numero').value).slice(-5) }}</strong>
                      <a *ngIf="entidade.empenho" [routerLink]="['/empenhos', entidade.empenho.id, 'visualizar']"
                        target="_blank" class="text-primary"
                        title="Empenho">#{{("00000"+entidade.empenho.numero).slice(-5)}}/{{entidade.empenho.exercicio.ano}}</a>
                    </div>

                  </div>
                  <div class="form-row mt-2">
                    <div class="col-md-4 form-group">
                      <label for="data_empenho">Data OF<span class="text-danger">*</span></label>
                      <p-calendar id="data_empenho" formControlName="data_compra"
                        (onBlur)="fichaAutoComplete.atualizar(false)" inputStyleClass="form-control" dataType="date"
                        dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                        [showButtonBar]="true" [style]="{ width: '100%' }">
                      </p-calendar>
                    </div>
                    <div class="col-md-4 form-group" formGroupName="rcms">
                      <label for="rcms">N˚ RCMS</label>
                      <input #numero_ formControlName="numero" type="text" class="form-control" id="rcms"
                        (blur)="visualizarRCMSEvent()">
                    </div>
                    <div class="col-md-4 form-group" formGroupName="contrato">
                      <label for="contrato">Contrato</label>
                      <input id="contrato" formControlName="numero" type="text" unmask="true"
                        [imask]="{mask: [ {mask: '0000/0000'}, {mask: '00000/0000'} ]}"
                        class="form-control font-weight-bold" (blur)="buscarContrato()">
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col-sm-12 form-group">
                      <label for="favorecido" style="display: block">Fornecedor<span
                          class="text-danger">*</span></label>
                      <div class="form-row">
                        <div class="form-group col-sm-2 mr-0 pr-0">
                          <input class="form-control font-weight-bold" type="text"
                            (blur)="favorecidoAutoComplete.atualizar(false)" [(ngModel)]="favorecidoAutoComplete.id"
                            name="favorecido_id" [ngModelOptions]="{standalone: true}" *ngIf="favorecidoAutoComplete"
                            placeholder="Código" />
                        </div>
                        <div class="form-group col-sm-10 ml-0 pl-0">
                          <p-autoComplete formControlName="favorecido" [field]="favorecidoAutoComplete.conversor"
                            [suggestions]="favorecidoAutoComplete.lista"
                            (completeMethod)="favorecidoAutoComplete.filtrar($event)"
                            placeholder="Informe cpf/cnpj ou nome/razão social"
                            inputStyleClass="form-control font-weight-bold" minLength="2" [style]="{ width: '100%' }"
                            (onSelect)="favorecidoAutoComplete.atualizar(true)" [forceSelection]="true"
                            [autoHighlight]="true" *ngIf="favorecidoAutoComplete">
                            <ng-template let-favorecido pTemplate="item">
                              {{favorecido.cpf_cnpj | CPF}} {{favorecido.nome}}
                            </ng-template>
                          </p-autoComplete>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row mt-2">
                    <div class="col-md-4 form-group" formGroupName="licitacao">
                      <label for="licitacao">Licitação</label>
                      <input formControlName="numero" type="text" class="form-control" id="licitacao"
                        [imask]="{mask: '00000/0000'}" unmask="true" (blur)="carregarLicitacao()">
                    </div>
                    <div class="col-sm-8 form-group">
                      <label for="modalidade">Modalidade<span class="text-danger">*</span></label>
                      <p-autoComplete #modalidade id="modalidade" formControlName="modalidade" [forceSelection]="true"
                        [autoHighlight]="true" [field]="modalidadeAutoComplete.conversor"
                        [suggestions]="modalidadeAutoComplete.lista" [dropdown]="true"
                        (completeMethod)="modalidadeAutoComplete.filtrar($event)" inputStyleClass="form-control"
                        minLength="2" [style]="{ width: '100%' }" (onFocus)="modalidade.handleDropdownClick($event)">
                        <ng-template let-modalidade pTemplate="item">
                          <strong>{{modalidade.codigo}}</strong> - {{modalidade.nome}}
                        </ng-template>
                      </p-autoComplete>
                    </div>
                  </div>
                  <div class="form-row mt-2">
                    <div class="col-md-4 form-group">
                      <label for="processo">Processo</label>
                      <input id="processo" formControlName="processo" type="text" [unmask]="false"
                        [imask]="{mask: '0000/0000'}" class="form-control">
                    </div>

                    <div class="col-md-4 form-group">
                      <label for="data_entrega">Data Entrega<span class="text-danger">*</span></label>
                      <p-calendar id="data_entrega" formControlName="data_entrega" inputStyleClass="form-control"
                        dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                        [showButtonBar]="true" [style]="{ width: '100%' }">
                      </p-calendar>
                    </div>
                    <div class="col-md-4 form-group">
                      <label for="data_pagamento">Data Pagamento<span class="text-danger">*</span></label>
                      <p-calendar id="data_pagamento" formControlName="data_pagamento" inputStyleClass="form-control"
                        dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false"
                        [showButtonBar]="true" [style]="{ width: '100%' }">
                      </p-calendar>
                    </div>
                  </div>
                  <div class="form-row mt-2">
                    <div class="col-md-8 form-group">
                      <label for="prazo">Prazo<span class="text-danger">*</span></label>
                      <p-autoComplete #prazo id="prazo" formControlName="prazo" [forceSelection]="true"
                        [autoHighlight]="true" [field]="prazoAutoComplete.conversor"
                        [suggestions]="prazoAutoComplete.lista" [dropdown]="true"
                        (completeMethod)="prazoAutoComplete.filtrar($event)" inputStyleClass="form-control"
                        minLength="2" [style]="{ width: '100%' }" (onFocus)="prazo.handleDropdownClick($event)">
                        <ng-template let-prazo pTemplate="item">
                          {{prazo.nome}}
                        </ng-template>
                      </p-autoComplete>
                    </div>
                    <div class="col-md-4">
                      <label for="tipo_compra">Tipo Compra<span class="text-danger">*</span></label>
                      <select [compareWith]="compareFn" formControlName="tipo_compra" id="tipo" class="form-control">
                        <option *ngFor="let item of listaTipos" [value]="item.id">{{item.nome}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-sm-8">
                      <label for="requerente">Requerente<span class="text-danger">*</span></label>
                      <p-autoComplete formControlName="requerente" [field]="pessoaAutoComplete.conversor"
                        [suggestions]="pessoaAutoComplete.lista" (completeMethod)="pessoaAutoComplete.filtrar($event)"
                        placeholder="Informe o Requerente" inputStyleClass="form-control autocomplete-radius-right"
                        minLength="2" [style]="{ width: 'calc(100% - 46px)', float: 'left' }" [forceSelection]="true"
                        [autoHighlight]="true" *ngIf="pessoaAutoComplete">
                        <ng-template let-pessoa pTemplate="item">
                          {{pessoa.cpf_cnpj | CPF}} {{pessoa.nome}}
                        </ng-template>
                      </p-autoComplete>
                      <button class="btn btn-outline-secondary float-right" type="button" data-toggle="modal"
                        data-target="#dialogPessoa"
                        style="height: 36px; border-bottom-left-radius: 0px;  border-top-left-radius: 0px;">
                        <em class="fa fa-user-plus"></em>
                      </button>
                    </div>
    
                  </div>

                </div>
                <div class="col-md-4">
                  <div class="card">
                    <ul class="list-group list-group-flush">
                      <li
                        class="list-group-item font-weight-bold bg-success d-flex justify-content-between align-items-center text-white">
                        <span>Saldo</span>
                        <em class="fa fa-eye float-right" (click)="visualizarFicha=true" style="cursor: pointer;"></em>
                      </li>
                      <li class="list-group-item">Dotação <span class="float-right">{{dadosCard.dotacao |
                          number:'1.2-2'}}</span>
                      </li>
                      <li class="list-group-item">Reservado <span class="float-right">{{dadosCard.reservado |
                          number:'1.2-2'}}</span></li>
                      <li class="list-group-item font-weight-bold text-white bg-info">
                        Total Compra <span class="float-right font-weight-bold">{{valorTotal() |
                          number:'1.2-2'}}</span>
                      </li>
                    </ul>
                  </div>

                  <div class="card mt-3">
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item pl-3 pr-3">
                        <div class="checkbox checbox-switch switch-danger">
                          <label>
                            <input formControlName="adiantamento" type="checkbox" />
                            <span></span>
                            Adiantamento
                          </label>
                        </div>
                      </li>
                      <li class="list-group-item pl-3 pr-3">
                        <div class="checkbox checbox-switch switch-primary">
                          <label>
                            <input formControlName="entregue_fornecedor" type="checkbox" />
                            <span></span>
                            Entregue ao fornecedor
                          </label>
                        </div>
                      </li>
                      <li class="list-group-item pl-3 pr-3">
                        <img alt="" src="assets/img/global/finish_and_merge.png" width="24" height="24" />
                        <span class="font-weight-light ml-1">Anexar precatório</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>              
              <hr class="mt-3 mb-2" />
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-row">
                    <div class="form-group col-sm-12">
                      <label for="ficha" style="display: block">Ficha de despesa<span
                          class="text-danger">*</span></label>
                      <div class="col-md-2 p-0 float-left">
                        <input class="form-control" type="text" (blur)="fichaAutoComplete.atualizar(false)"
                          [(ngModel)]="fichaAutoComplete.id" name="ficha_id" [ngModelOptions]="{standalone: true}"
                          *ngIf="fichaAutoComplete" placeholder="Código" />
                      </div>
                      <div class="col-sm-10 p-0 float-left">
                        <p-autoComplete formControlName="ficha" [field]="fichaAutoComplete.conversor"
                          [suggestions]="fichaAutoComplete.lista" (completeMethod)="fichaAutoComplete.filtrar($event)"
                          placeholder="Informe a descrição do elemento da despesa" inputStyleClass="form-control"
                          minLength="2" [style]="{ width: '100%' }" (onSelect)="fichaAutoComplete.atualizar(true)"
                          (onBlur)="fichaAutoComplete.atualizar(true)" [forceSelection]="true" [autoHighlight]="true"
                          *ngIf="fichaAutoComplete">
                          <ng-template let-ficha pTemplate="item">
                            {{ ficha.numero }} - {{ficha.despesa.nome}}
                          </ng-template>
                        </p-autoComplete>
                      </div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-sm-12">
                      <label for="subelemento" style="display: block">Subelemento da despesa<span
                          class="text-danger">*</span></label>
                      <div class="col-sm-2 p-0 float-left">
                        <input class="form-control" type="text" (blur)="subElementoAutoComplete.atualizar(false)"
                          onfocus="let value = this.value; this.value = null; this.value=value"
                          [(ngModel)]="subElementoAutoComplete.id" name="subElemento_id"
                          [ngModelOptions]="{standalone: true}" unmask="unmask" [imask]="{mask: '0.0.00.00.00.000'}"
                          *ngIf="subElementoAutoComplete" placeholder="Código" />
                      </div>
                      <div class="form-group col-sm-10 p-0 float-left">
                        <p-autoComplete formControlName="subelemento" [field]="subElementoAutoComplete.conversor"
                          [suggestions]="subElementoAutoComplete.lista"
                          (completeMethod)="subElementoAutoComplete.filtrar($event)"
                          placeholder="Informe a descrição do subelemento" inputStyleClass="form-control" minLength="2"
                          [style]="{ width: '100%' }" (onSelect)="subElementoAutoComplete.atualizar(true)"
                          [forceSelection]="true" [autoHighlight]="true" *ngIf="subElementoAutoComplete">
                          <ng-template let-subElemento pTemplate="item">
                            {{subElemento.codigo}} - {{subElemento.nome}}
                          </ng-template>
                        </p-autoComplete>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="form-row">
                <div class="form-group col-12">
                  <label for="obs">Observação</label>
                  <textarea formControlName="observacao" class="form-control" id="obs" rows="3"></textarea>
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
              <app-compra-item [usarAtalho]="tabSelecionado(2)" [(lista)]="listaItens" [(login)]="login">
              </app-compra-item>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<lib-pessoa-cadastro-dlg [entity]="entidadeForm.get('requerente').value" [login]="login"></lib-pessoa-cadastro-dlg>
<lib-compra-selecionar-item-dlg [lista]="selecionar" (finalizado)="posSelecionarItens($event)">
</lib-compra-selecionar-item-dlg>
<app-compra-rcms-dlg [(visualizar)]="visualizarRCMS" [login]="login" [numero]="entidadeForm.get('rcms').value.numero"
  (selecionarFavorecido)="selecionarRCMS($event)"></app-compra-rcms-dlg>
<app-saldo-ficha-dlg [ficha]="this.entidade.ficha ? this.entidade.ficha : this.entidadeForm.get('ficha').value"
  [login]="login"
  [data]="this.entidade.data_compra ? this.entidade.data_compra : this.entidadeForm.get('data_compra').value"
  [(visualizar)]="visualizarFicha">
</app-saldo-ficha-dlg>
<app-exclusao-compra-dlg [(visualizar)]="visualizarExclusao" [compra]="entidade" [login]="login">
</app-exclusao-compra-dlg>